import { render, staticRenderFns } from "./dataset.md?vue&type=template&id=175a8ca2&"
import script from "./dataset.md?vue&type=script&lang=js&"
export * from "./dataset.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175a8ca2')) {
      api.createRecord('175a8ca2', component.options)
    } else {
      api.reload('175a8ca2', component.options)
    }
    module.hot.accept("./dataset.md?vue&type=template&id=175a8ca2&", function () {
      api.rerender('175a8ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/dataset.md"
export default component.exports